define('base/collection',['require','exports','module','backbone'],function(require, exports, module) {
  "use strict";

  var Backbone = require("backbone");

  module.exports = Backbone.Collection.extend({
    set: function() {
      this._timestamp = (new Date()).getTime();
      return module.exports.__super__.set.apply(this, arguments);
    },
    reset: function() {
      this._timestamp = (new Date()).getTime();
      return module.exports.__super__.reset.apply(this, arguments);
    },
    isNew: function() {
      return !this._timestamp;
    },
    maybeFetch: function(options) {
      if (this.isNew()) {
        this.fetch(options);
      }
    },
    onReady: function(cb, ctx) {
      if (this.isNew()) {
        this.once("sync", cb, ctx);
        this.fetch();
      } else {
        cb.call(ctx);
      }
    }
  });
});

